import { render, staticRenderFns } from "./AccountingDocsListMobile.vue?vue&type=template&id=66930566&scoped=true&"
import script from "./AccountingDocsListMobile.vue?vue&type=script&lang=js&"
export * from "./AccountingDocsListMobile.vue?vue&type=script&lang=js&"
import style0 from "./AccountingDocsListMobile.vue?vue&type=style&index=0&id=66930566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66930566",
  null
  
)

export default component.exports